import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useMe } from "../../../swr/useMe";
import { authSession } from "../token_store";
import { authSessionService } from "../../api_client";
import { AppRoutes } from "../../../common/routes/app_routes";

import { useCartStore } from "../../../hooks/stores/useCartStore";
import { useMePartner } from "../../../swr";
import { useWishlistStore } from "../../products/domain/stores/useWishlistStore";

export function useLogout() {
    const { mutate: mutateMe } = useMe();
    const { mutate: mutateMePartner } = useMePartner();
    const navigate = useNavigate();

    const handleLogout = useCallback(async () => {
        try {
            await authSessionService.logout();
        } catch (error) {
            console.error("Logout error:", error);
        } finally {
            localStorage.clear();
            useCartStore.setState({ items: [] });
            useWishlistStore.getState().clear();
            authSession.clear();
            mutateMe?.(undefined);
            // Clear partner cache
            mutateMePartner(
                undefined,
                { revalidate: false }
            );
            navigate(AppRoutes.INDEX);
        }
    }, [ mutateMe, mutateMePartner, navigate ]);

    return handleLogout;
}

